export default "__VITE_ASSET__jpRBgtf0__"